import { Entry } from 'contensis-management-api';
import getUuidByString from 'uuid-by-string';
import { Logger } from '~/util/logger';

export const generateGuid = (
  alias: string,
  projectId: string,
  guid: string,
  nodePath?: string
) => {
  if (!guid) return guid;
  const hash = `${alias?.toLowerCase()}-${projectId?.toLowerCase()}-${guid?.toLowerCase()}${
    nodePath ? nodePath.toLowerCase() : ''
  }`;
  const nextGuid = getUuidByString(hash);
  // Logger.info(`Generating guid from '${hash}' created '${nextGuid}'`);
  return nextGuid;
};

export class TransformGuidFactory {
  private transformer: (guid: string, nodePath?: string) => string = (guid) =>
    guid;

  constructor(private transformGuids: boolean) {}

  create = (alias: string, projectId: string) => {
    if (this.transformGuids) {
      this.transformer = (guid: string, nodePath?: string) =>
        generateGuid(alias, projectId, guid, nodePath);
    } else {
      this.transformer = (guid: string, nodePath?: string) => guid;
    }
    return this.transformer;
  };

  generate = (alias: string, projectId: string) => {
    return (hash: string, nodePath?: string) =>
      generateGuid(alias, projectId, hash, nodePath);
  };

  logId = (link: Entry) => {
    const transformedId = this.transformer(link?.sys?.id || '');

    if (transformedId !== link?.sys?.id)
      return `${Logger.boldText(transformedId)}<-${link?.sys?.id}`;
    return link?.sys?.id;
  };
}
